<template>
    <div class="full-backdrop">
        <div class="content">
            <slot>

            </slot>
        </div>
    </div>
</template>

<script>
  export default {
      beforeCreate(){
          document.body.classList.add('backdrop-open');
      },
      beforeDestroy(){
          document.body.classList.remove('backdrop-open');
      }
  }
</script>

<style lang="scss">
    .full-backdrop{
        position: fixed;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;

        background-color: rgba(0,0,0,.65);
        z-index: 9999999;
        display: flex;
        align-items: center;
        justify-content: center;

        /* Hide scrollbar for Chrome, Safari and Opera */
        .content::-webkit-scrollbar {
            display: none;
        }

        .content{
            max-height: 90%;
            overflow-y: auto;

            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */

            background-color: #ffffff;
            width: auto;
            box-shadow: 0 0 5px rgba(0,0,0,.5);
            box-sizing: border-box;
            border-radius: 1rem;
            padding: 1rem;

            @media(max-width: 768px){
                width: 90%;
            }

            .container{
                padding: 2em;
            }
        }
    }


    body.backdrop-open{
        overflow: hidden;
        width: 100%;
        height: 100vh;
        transition: filter 2s;
        //filter: blur(3px);
    }
</style>
